<template>
  <v-row dense justify="center">
    <v-col cols="12" md="10" lg="8" class="title d-flex align-center">
      <v-icon color="secondary" left>mdi-account</v-icon> Perfil
    </v-col>
    <v-col cols="12" md="10" lg="8">
      <v-card outlined flat>
        <v-card-text>
          <v-form @submit="submit" v-model="form.valid" ref="form" id="profile" lazy-validation>
            <v-text-field
              label="Nome"
              v-model="user.name"
              :rules="form.nameRules"
              required/>
            <v-text-field
              label="E-mail"
              v-model="user.email"
              :rules="form.emailRules"
              required/>
            <v-text-field
              label="Matrícula do aluno"
              v-model="user.person.student.student_number"
              disabled/>
            <v-text-field
              label="Data de nascimento"
              v-model="user.dataNascimento"
              disabled/>
            <v-text-field
              label="CPF"
              v-model="user.CPF"
              disabled/>
            <v-select
              label="Gênero"
              v-model="user.genero"
              :items="form.generoItems"/>
            <v-select
              label="Identidade de Gênero"
              v-model="user.identidadeGenero"
              :items="form.identidadeGeneroItems"/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="$router.back()">Cancelar</v-btn>
          <v-btn text type="submit" form="profile" :disabled="!form.valid" color="success">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import store from '@/store'
import { User } from '@/services/resources'
import { mapGetters } from 'vuex'

export default {
  mounted () {
    User.get().then(response => {
      store.commit('App/setUser', response.data.user)
      this.user = Object.assign({}, this.userState)
    })
  },
  data () {
    return {
      user: {
        name: '',
        email: '',
        genero: '',
        identidadeGenero: '',
        naturalidade: '',
        dataNascimento: '',
        CPF: '',
        person: {
          student: {
            student_number: null
          }
        }
      },
      form: {
        valid: true,
        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length <= 140) || 'Name must be less than 10 characters'
        ],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        select: null,
        generoItems: [
          {
            text: 'Masculino',
            value: 'M'
          },
          {
            text: 'Feminino',
            value: 'F'
          }
        ],
        identidadeGeneroItems: [
          {
            text: 'Masculino',
            value: 'M'
          },
          {
            text: 'Feminino',
            value: 'F'
          },
          {
            text: 'Não Binário',
            value: 'NB'
          },
          {
            text: 'Não Informado',
            value: 'NI'
          }
        ],
        checkbox: false
      }
    }
  },
  methods: {
    submit () {
      console.log('submit')
      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  },
  computed: {
    ...mapGetters({
      userState: 'App/user'
    })
  }
}
</script>
